module.exports = __webpack_public_path__ + "static/media/settings.9d22fd06.svg";